export class AbstractGenerator {
  constructor(public name: string) {}

  generate(): number[] {
    return [];
  }
}
